<template>
  <div id="app" :style="styleWhiteLabel">
    <template v-if="!loading">
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import hexToHsl from "hex-to-hsl";
import { WhiteLabelResource } from "@/resources/WhiteLabel.resource.js";
export default {
  name: "app",
  components: {},
  data() {
    return {
      domainConfigs: {},
      loading: true
    };
  },
  computed: {
    ...mapGetters(["user"]),
    styleWhiteLabel() {
      try {
        const cores = JSON.parse(this.domainConfigs.colors);
        const coresIndex = Object.keys(JSON.parse(this.domainConfigs.colors));

        const ret = {};
        coresIndex.forEach(item => {
          try {
            const cor = hexToHsl(cores[item]);
            const corBase = `${cor[0]},${cor[1]}%,${cor[2]}%`;

            ret[`--${item}`] = `hsl(${corBase})`;
            ret[`--${item}-light`] = `hsl(${cor[0]},${cor[1]}%,${parseInt(
              cor[2]
            ) + 10}%)`;
            ret[`--${item}-dark`] = `hsl(${cor[0]},${cor[1]}%,${parseInt(
              cor[2]
            ) - 5}%)`; //white5%era10
          } catch (e) {
            ret[`--${item}`] = this.domainConfigs[item];
          }
        });

        return ret;
      } catch (e) {
        return {};
      }
    },
    siteTitle() {
      try {
        return this.domainConfigs.name || "asd";
      } catch (e) {
        return "asd";
      }
    }
  },
  created() {
    this.getWhiteLabel();
  },

  methods: {
    ...mapActions({
      setConfig: "setConfig"
    }),
    getWhiteLabel() {
      const v = this;
      WhiteLabelResource.get({
        url: window.location.hostname
      })
        .then(response => {
          try {
            v.domainConfigs = response.data.payload;
          } catch (e) {
            v.domainConfigs = {};
          }
          v.setConfig(this.domainConfigs);

          // agora temos o nome, verificamso se ele esta no titulo
          if (!document.title.includes(v.domainConfigs.name)) {
            document.title = `${v.domainConfigs.name} | ${document.title}`;
          }

          // muda o favicon
          try {
            v.updateFavicon(v.domainConfigs.favicon);
          } catch (e) {
            // Surpress
          }
        })
        .catch(() => {
          this.setConfig({});
        })
        .finally(() => {
          this.loading = false;
        });
    },
    nextRoute(auth) {
      let url = "/";
      if (auth.role === "MerchantAdmin") {
        url = "/dashboard/analytics/ec";
      }
      else if (auth.role === "PartnerAdmin" || auth.role === "PartnerUser") {
        url = "/dashboard/analytics/pt";
      }
      else if (auth.role === "RepresentativeAdmin" || auth.role === "RepresentativeUser") {
        url = "/dashboard/analytics/rt";
      }
      else if (auth.role === "ResellerAdmin" || auth.role === "ResellerUser") {
        url = "/dashboard/analytics/rs";
      }

      return this.$route.query.redirect || url;
    },
    updateFavicon(favicon) {
      if (
        typeof favicon !== "undefined" &&
        favicon !== "" &&
        favicon !== null
      ) {
        const tagFavicon = document.getElementById("favicon");
        tagFavicon.href = favicon;
      }
    }
  },
  watch: {
    user(auth) {
      if (auth) {
        this.$router.replace(this.nextRoute(auth));
      }
    },
    $route(to, from) {
      const query = Object.assign({}, to.query);
      this.$store.commit("SETUP_URL_SETTINGS", query);
    }
  }
};
</script>

<style>
/** config inicial para  */
:root {
  --primaryColor: #103063;
  --primaryColor-light: #1b55e3;
  --primaryColor-dark: #091c3a;
  --secondaryColor: #103063;
  --secondaryColor-light: #aca6cc;
  --secondaryColor-dark: #786fa4;
}
</style>
